// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__22eaE","question":"Question_question__VaNLU","description":"Question_description__34FD-"};